import { Api, decryptApiResponse} from "../../../../config/Api";
import { statusAndResponse } from "../../../../util/requestHandler";

export const getRingCentralMessages = async (queryParams) => {
  return statusAndResponse(
    Api.get(`/api/sms/v1/ringcentral/messages?${queryParams}`),
      decryptApiResponse,
  );
};
